import { createSlice } from '@reduxjs/toolkit';
import { PublicFreemiumReportsState } from './public-freemium-reports.state';
import { fetchPublicFreemiumReports } from './thunks/fetch-public-freemium-reports.thunk';
import { fetchPublicFreemiumReportDetails } from './thunks/fetch-public-freemium-report-details.thunk';

const initialState: PublicFreemiumReportsState = {
    items: [],
    totalCount: 0,
    isLoading: false,
    details: null,
    isDetailsLoading: false,
    status: 'succeeded',
    error: '',
};

const publicFreemiumReportsSlice = createSlice({
    name: 'publicFreemiumReports',
    initialState,
    reducers: {
        clearPublicFreemiumReportDetails(state) {
            state.details = null;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchPublicFreemiumReports.pending, (state) => {
                state.isLoading = true;
                state.status = 'loading';
                state.error = '';
            })
            .addCase(fetchPublicFreemiumReports.fulfilled, (state, action) => {
                state.items = action.payload.items;
                state.totalCount = action.payload.totalCount;
                state.isLoading = false;
                state.status = 'succeeded';
            })
            .addCase(fetchPublicFreemiumReports.rejected, (state) => {
                state.isLoading = false;
                state.status = 'failed';
            })
            .addCase(fetchPublicFreemiumReportDetails.pending, (state) => {
                state.details = null;
                state.isDetailsLoading = true;
            })
            .addCase(fetchPublicFreemiumReportDetails.fulfilled, (state, action) => {
                state.details = action.payload;
                state.isDetailsLoading = false;
            })
            .addCase(fetchPublicFreemiumReportDetails.rejected, (state) => {
                state.isDetailsLoading = false;
            });
    },
});

export const { clearPublicFreemiumReportDetails } = publicFreemiumReportsSlice.actions;
export default publicFreemiumReportsSlice.reducer;
